import { render, staticRenderFns } from "./correspondence-list.vue?vue&type=template&id=c36d22e6&scoped=true"
import script from "./correspondence-list.vue?vue&type=script&lang=js"
export * from "./correspondence-list.vue?vue&type=script&lang=js"
import style0 from "./correspondence-list.vue?vue&type=style&index=0&id=c36d22e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c36d22e6",
  null
  
)

export default component.exports